import { useNavigate, NavigateFunction } from 'react-router-dom';

// Store the navigate function globally
let navigationFunction: NavigateFunction | null = null;

// Set the navigation function
export const setNavigate = (navigate: NavigateFunction) => {
  navigationFunction = navigate;
};

// Get the navigation function
export const getNavigate = () => {
  if (!navigationFunction) {
    throw new Error('Navigation function not set. Make sure to call setNavigate first.');
  }
  return navigationFunction;
};

// Custom hook to handle navigation
export const useAppNavigation = () => {
  const navigate = useNavigate();
  
  return {
    goTo: (path: string, options?: { replace?: boolean }) => {
      navigate(path, options);
    },
    goBack: () => {
      navigate(-1);
    }
  };
};

// Direct navigation function for non-component code
export const navigate = (path: string, options?: { replace?: boolean }) => {
  const nav = getNavigate();
  nav(path, options);
};